import { render, staticRenderFns } from "./FFFContainerPanel.vue?vue&type=template&id=450eb84a"
import script from "./FFFContainerPanel.vue?vue&type=script&lang=ts"
export * from "./FFFContainerPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports